import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import FieldGrid from './FieldGrid';
import HelperText from '../helper-text';

const RadioButtonGroup = ({
  // value,
  // error,
  // touched,
  // id,
  error,
  label,
  children,
  styles,
  isDisabled,
  isDark,
  gridFlow,
  gridComponent: GridComponent,
}) => {
  const childrenWithProps = React.Children.map(children, child => (
    React.cloneElement(child, { isDark })
  ));

  return (
    <Fieldset styles={styles} disabled={isDisabled}>
      {label && <Legend isDark={isDark}>{label}</Legend> }
      <GridComponent gridFlow={gridFlow}>
        {childrenWithProps}
      </GridComponent>
      {error &&
      <HelperText styles="bottom: -1rem;">
        <HelperText.Error>
          {error}
        </HelperText.Error>
      </HelperText>
      }
      {/* {touched && <InputFeedback error={error} />} */}
    </Fieldset>
  );
};

const Fieldset = styled.fieldset`
  position: relative;
  opacity: ${props => props.disabled ? '0.5' : 1};
  border: 0;
  padding: 0;
  margin: 0;

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

const Legend = styled.legend`
  width: 100%;
  margin-bottom: 20px;
  font-size: 1rem;
  color: ${props => props.isDark ? '#808080;' : rgba(props.theme.blue, 0.75)};
`;

RadioButtonGroup.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  styles: PropTypes.string,
  gridFlow: PropTypes.string,
  gridComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
};

RadioButtonGroup.defaultProps = {
  gridComponent: FieldGrid,
};

export default RadioButtonGroup;
